module.exports = __webpack_public_path__ + "img/title_down_1.846fd694.png";